import {ExternalChatOrganization, ExternalChatUserState,} from "domain-entities";
import {isImageMimeType} from "Helpers/AssetHelper";
import {useApp} from "Providers/AppProvider";

export function isOrganizationAdded(
    userState: ExternalChatUserState,
    organization?: ExternalChatOrganization
): organization is ExternalChatOrganization {
  return organization
      ? userState.organizationsAdded.includes(organization.id)
      : false;
}

export function useGetOrganizationAvatarUrl() {
  const { firebaseStorage } = useApp();

  return async (organization: ExternalChatOrganization) => {
    if (organization.icons?.length) {
      const imageIcon = organization.icons.find((icon) =>
        isImageMimeType(icon.mimeType)
      );

      if (imageIcon) {
        return firebaseStorage?.ref(imageIcon.location).getDownloadURL();
      }
    }
  };
}
